const DEVELOPMENT = false;
let configuration = DEVELOPMENT ? {
    BASE_URL : "http://localhost:4000/admin"
} : {
    BASE_URL : "https://application.mrpizza.pt/admin"
}

export default configuration;